export default __webpack_public_path__ + "static/media/Grace.1bab3227.png";